import React, { useState, useEffect, useCallback } from "react";
import toast from "../helpers/toast";
import Httpconfig from "../helpers/HttpconfigAdmin";
import * as SecureLS from "secure-ls";
import Constant from "../../constants";
import { Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import DiagnosisHeader from "./DiagnosisHeader";
import DiagnosisMenu from "./DiagnosisMenu";
const moment = require("moment");

// Add custom styles for datepicker
const customStyles = `
  .custom-datepicker {
    border-radius: 4px !important;
    font-size: 15px !important;
    letter-spacing: 0px !important;
    color: #1f1f1f !important;
    opacity: 1 !important;
    height: 44px !important;
    margin: 0px !important;
    display: block !important;
    width: 100% !important;
    padding: 0.375rem 2.5rem 0.375rem 0.75rem !important;
    font-weight: 400 !important;
    line-height: 1.5 !important;
    background-color: #fff !important;
    background-clip: padding-box !important;
    border: 1px solid #ced4da !important;
    min-width: 180px !important;
  }
  
  .custom-datepicker:focus {
    outline: none !important;
    border-color: #00B7CE !important;
    box-shadow: 0 0 0 0.2rem rgba(0, 183, 206, 0.25) !important;
  }

  .custom-button-primary:hover {
    background-color: #009fb5 !important;
    border-color: #009fb5 !important;
  }

  .custom-button-secondary:hover {
    background-color: #00B7CE !important;
    color: #fff !important;
  }

  .custom-edit-icon:hover {
    color: #009fb5 !important;
    transform: scale(1.1);
  }
`;

// Inject styles into head
if (typeof document !== "undefined") {
  const styleTag = document.createElement("style");
  styleTag.innerHTML = customStyles;
  if (!document.getElementById("custom-datepicker-styles")) {
    styleTag.id = "custom-datepicker-styles";
    document.head.appendChild(styleTag);
  }
}

var ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "medleymed",
});
const diagnosticsuserObj = ls.get("diagnosticsuserObj");
let diagnosis_id = diagnosticsuserObj && diagnosticsuserObj.diagnosis_id;

const early_morning_slots = ["6:00 AM", "7:00 AM", "8:00 AM"];
const morning_slots = ["9:00 AM", "10:00 AM", "11:00 AM"];
const noon_slots = ["12:00 PM", "1:00 PM", "2:00 PM", "3:00 PM"];
const evening_slots = ["4:00 PM", "5:00 PM", "6:00 PM", "7:00 PM"];

const currentDate = new Date();
const sevenDays = new Date(currentDate);
sevenDays.setDate(currentDate.getDate() + 7);

const SlotsConfiguration = (props) => {
  // Responsive helper
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  );

  useEffect(() => {
    const onResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const isNarrow = windowWidth < 768;

  const styles = {
    container: { padding: 12, boxSizing: "border-box" },
    headerRow: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      gap: 8,
    },
    title: { fontSize: 20, margin: 0 },
    dateGroup: {
      display: "flex",
      alignItems: "center",
      gap: 8,
      flexWrap: "wrap",
    },
    datePickerWrapper: {
      position: "relative",
      display: "inline-block",
    },
    datePickerInput: {
      borderRadius: "4px",
      fontSize: "15px",
      letterSpacing: "0px",
      color: "#1f1f1f",
      opacity: 1,
      height: "44px",
      margin: "0px",
      display: "block",
      width: "100%",
      padding: "0.375rem 2.5rem 0.375rem 0.75rem",
      fontWeight: 400,
      lineHeight: 1.5,
      backgroundColor: "#fff",
      backgroundClip: "padding-box",
      border: "1px solid #ced4da",
      minWidth: "180px",
    },
    calendarIcon: {
      position: "absolute",
      right: "12px",
      top: "50%",
      transform: "translateY(-50%)",
      pointerEvents: "none",
      color: "#495057",
      fontSize: "16px",
    },
    slotBox: {
      border: "1px solid #e0e0e0",
      borderRadius: 6,
      padding: 10,
      marginBottom: 12,
    },
    slotRow: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      gap: 8,
    },
    slotLabel: { minWidth: 130, flex: "0 0 auto" },
    select: {
      borderRadius: "4px",
      fontSize: "15px",
      letterSpacing: "0px",
      color: "#1f1f1f",
      opacity: 1,
      height: "44px",
      margin: "0px",
      display: "block",
      width: "100%",
      minWidth: "110px",
      padding: "0.375rem 0.75rem",
      fontWeight: 400,
      lineHeight: 1.5,
      backgroundColor: "#fff",
      backgroundClip: "padding-box",
      border: "1px solid #ced4da",
    },
    arrow: {
      width: 18,
      height: 18,
      display: "inline-block",
      textAlign: "center",
    },
    buttonRow: { display: "flex", gap: 8, flexWrap: "wrap", marginTop: 8 },
    slotsGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
      gap: "12px",
      marginBottom: "12px",
    },
    button: {
      padding: "0.5rem 1.5rem",
      fontSize: "15px",
      fontWeight: 500,
      borderRadius: "4px",
      border: "2px solid #00B7CE",
      backgroundColor: "#00B7CE",
      color: "#fff",
      cursor: "pointer",
      transition: "all 0.3s ease",
      height: "44px",
    },
    buttonSecondary: {
      padding: "0.5rem 1.5rem",
      fontSize: "15px",
      fontWeight: 500,
      borderRadius: "4px",
      border: "2px solid #00B7CE",
      backgroundColor: "#fff",
      color: "#00B7CE",
      cursor: "pointer",
      transition: "all 0.3s ease",
      height: "44px",
    },
    editIcon: {
      color: "#00B7CE",
      cursor: "pointer",
      fontSize: "18px",
      marginLeft: "8px",
    },
  };
  // dynamic layout padding to avoid header/sidebar overlap
  const [layoutPadding, setLayoutPadding] = useState({
    paddingTop: 0,
    paddingLeft: 0,
  });

  useEffect(() => {
    const computePadding = () => {
      let paddingTop = 0;
      let paddingLeft = 0;
      try {
        const header = document.getElementById("header");
        const side = document.getElementById("side_Nav");
        if (header) paddingTop = header.getBoundingClientRect().height + 8;
        if (side && window.innerWidth >= 992)
          paddingLeft = side.getBoundingClientRect().width + 12;
      } catch (e) {
        // ignore in non-browser env
      }
      setLayoutPadding({ paddingTop, paddingLeft });
    };
    computePadding();
    window.addEventListener("resize", computePadding);
    return () => window.removeEventListener("resize", computePadding);
  }, []);
  // State for form fields
  const [fields, setFields] = useState({
    isEarlyMorningChecked: true,
    isMorningChecked: true,
    isAfternoonChecked: true,
    isEveningChecked: true,
    early_morning_from: "6:00 AM",
    early_morning_to: "8:00 AM",
    morning_range_from: "9:00 AM",
    morning_range_to: "11:00 AM",
    noon_from: "12:00 PM",
    noon_to: "3:00 PM",
    evening_from: "4:00 PM",
    evening_to: "7:00 PM",
    start_date: currentDate,
    end_date: sevenDays,
  });

  // State for errors and fetched data
  const [errors, setErrors] = useState({});
  const [fetchedSlotConfigs, setFetchedSlotConfigs] = useState([]);
  const [selectedConfigIdx, setSelectedConfigIdx] = useState(null);
  const [update, setUpdate] = useState("");

  // Fetch diagnosis slots on mount
  useEffect(() => {
    if (diagnosis_id) {
      fetchDiagnosisSlots(diagnosis_id);
      setUpdate("edit");
    }
  }, []);

  // Fetch the Diagnosis Appointment Slots
  const fetchDiagnosisSlots = useCallback(async (id) => {
    try {
      const response = await Httpconfig.httptokenpost(
        Constant.siteurl + "api/diagnosis/getDiagnosisSlots",
        { diagnosis_id: id }
      );
      if (Array.isArray(response.data?.data)) {
        setFetchedSlotConfigs(response.data.data);
        setSelectedConfigIdx(null); // Do not preselect or prefill
      } else {
        setFetchedSlotConfigs([]);
        setSelectedConfigIdx(null);
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  // Prefill form fields from a slot config
  const prefillFieldsFromConfig = useCallback((config) => {
    if (!config) return;
    const { date_range, slots } = config;
    setFields((prev) => {
      const newFields = { ...prev };
      newFields.start_date = moment(date_range.from, "DD-MM-YYYY").toDate();
      newFields.end_date = moment(date_range.to, "DD-MM-YYYY").toDate();
      // Early Morning
      if (slots["Early Morning"]?.length > 0) {
        newFields.isEarlyMorningChecked = true;
        newFields.early_morning_from = slots["Early Morning"][0];
        newFields.early_morning_to =
          slots["Early Morning"][slots["Early Morning"].length - 1];
      } else {
        newFields.isEarlyMorningChecked = false;
      }
      // Morning
      if (slots["Morning"]?.length > 0) {
        newFields.isMorningChecked = true;
        newFields.morning_range_from = slots["Morning"][0];
        newFields.morning_range_to =
          slots["Morning"][slots["Morning"].length - 1];
      } else {
        newFields.isMorningChecked = false;
      }
      // After Noon
      if (slots["After Noon"]?.length > 0) {
        newFields.isAfternoonChecked = true;
        newFields.noon_from = slots["After Noon"][0];
        newFields.noon_to = slots["After Noon"][slots["After Noon"].length - 1];
      } else {
        newFields.isAfternoonChecked = false;
      }
      // Evening
      if (slots["Evening"]?.length > 0) {
        newFields.isEveningChecked = true;
        newFields.evening_from = slots["Evening"][0];
        newFields.evening_to = slots["Evening"][slots["Evening"].length - 1];
      } else {
        newFields.isEveningChecked = false;
      }
      return newFields;
    });
  }, []);

  // Helper to get closest slot value from slot arrays
  const getClosestSlot = useCallback((slot, slotArray) => {
    let found = slotArray.find((s) => {
      return (
        s.replace(/\s/g, "") === slot.replace(/\s/g, "") ||
        moment(s, ["hh:mm A", "H:mm"]).format("H:mm A") === slot ||
        moment(s, ["hh:mm A", "H:mm"]).format("HH:mm") ===
          slot.replace(" PM", "")
      );
    });
    return found || slotArray[0];
  }, []);

  // Handler for editing all slots and date range (for selected config)
  const onEditAllSlotsAndDateRange = useCallback(
    (idx) => {
      if (fetchedSlotConfigs[idx]) {
        setSelectedConfigIdx(idx);
        prefillFieldsFromConfig(fetchedSlotConfigs[idx]);
      }
    },
    [fetchedSlotConfigs, prefillFieldsFromConfig]
  );

  // When value changes of the fields
  const handleChange = useCallback((field, event) => {
    const value = event.target.value;
    setFields((prev) => ({ ...prev, [field]: value }));
  }, []);

  // Toggle functions
  const toggleEarlyMorningChange = useCallback(() => {
    setFields((prev) => ({
      ...prev,
      isEarlyMorningChecked: !prev.isEarlyMorningChecked,
    }));
  }, []);

  const toggleMorningChange = useCallback(() => {
    setFields((prev) => ({
      ...prev,
      isMorningChecked: !prev.isMorningChecked,
    }));
  }, []);

  const toggleAfternoonChange = useCallback(() => {
    setFields((prev) => ({
      ...prev,
      isAfternoonChecked: !prev.isAfternoonChecked,
    }));
  }, []);

  const toggleEveningChange = useCallback(() => {
    setFields((prev) => ({
      ...prev,
      isEveningChecked: !prev.isEveningChecked,
    }));
  }, []);

  const toggleNightChange = useCallback(() => {
    setFields((prev) => ({
      ...prev,
      isNightChecked: !prev.isNightChecked,
    }));
  }, []);

  // Create or update
  const checkSubmit = useCallback(
    async (event) => {
      event.preventDefault();
      if (!diagnosis_id) {
        toast.error("Diagnosis ID not found in local storage.");
        return;
      }
      if (!handleValidation()) {
        toast.warn("Form has errors.");
        return;
      }
      // Prepare date_range
      const date_range = {
        from: moment(fields.start_date).format("DD-MM-YYYY"),
        to: moment(fields.end_date).format("DD-MM-YYYY"),
      };
      // Prepare slots object
      const slots = {};
      // Helper functions
      const getSlotRange = (slotArray, from, to) => {
        const fromIdx = slotArray.indexOf(from);
        const toIdx = slotArray.indexOf(to);
        if (fromIdx === -1 || toIdx === -1 || fromIdx > toIdx) return [];
        return slotArray.slice(fromIdx, toIdx + 1);
      };
      const formatSlotTime = (slot) => {
        return slot.replace(/^0/, "");
      };
      // Early Morning
      if (fields.isEarlyMorningChecked) {
        const earlyMorning = getSlotRange(
          early_morning_slots,
          fields.early_morning_from,
          fields.early_morning_to
        ).map(formatSlotTime);
        if (earlyMorning.length > 0) {
          slots["Early Morning"] = earlyMorning;
        }
      }
      // Morning
      if (fields.isMorningChecked) {
        const morning = getSlotRange(
          morning_slots.concat(["12:00 PM"]),
          fields.morning_range_from,
          "12:00 PM"
        ).map(formatSlotTime);
        if (morning.length > 0) {
          slots["Morning"] = morning;
        }
      }
      // After Noon
      if (fields.isAfternoonChecked) {
        const noonSlots = getSlotRange(
          noon_slots,
          fields.noon_from,
          fields.noon_to
        );
        let afterNoon = [];
        noonSlots.forEach((slot) => {
          const hour24 = moment(slot, ["hh:mm A"]).format("HH");
          if (parseInt(hour24) >= 13) {
            afterNoon.push(moment(slot, ["hh:mm A"]).format("H") + ":00 PM");
          }
        });
        afterNoon = afterNoon.map(formatSlotTime);
        if (afterNoon.length > 0) {
          slots["After Noon"] = afterNoon;
        }
      }
      // Evening
      if (fields.isEveningChecked) {
        const evngSlots = getSlotRange(
          evening_slots,
          fields.evening_from,
          fields.evening_to
        );
        let evening = [];
        evngSlots.forEach((slot) => {
          const hour24 = moment(slot, ["hh:mm A"]).format("HH");
          if (parseInt(hour24) >= 16) {
            evening.push(moment(slot, ["hh:mm A"]).format("H") + ":00 PM");
          }
        });
        evening = evening.map(formatSlotTime);
        if (evening.length > 0) {
          slots["Evening"] = evening;
        }
      }
      // Call API
      try {
        const response = await Httpconfig.httptokenpost(
          Constant.siteurl + "api/diagnosis/setSlots",
          { diagnosis_id, date_range, slots }
        );
        if (response.data?.status === 200) {
          toast.success("Slots successfully saved.");
          fetchDiagnosisSlots(diagnosis_id);
        } else {
          toast.error(response.data?.message || "Error saving slots.");
        }
      } catch (error) {
        toast.error(error.response.data.message || "Error");
      }
    },
    [fields, fetchDiagnosisSlots]
  );

  // Validation
  const handleValidation = useCallback(() => {
    const newErrors = {};
    let formIsValid = true;
    if (!fields.start_date) {
      formIsValid = false;
      newErrors.start_date = "Start Date cannot be empty";
    }
    if (!fields.end_date) {
      formIsValid = false;
      newErrors.end_date = "End Date cannot be empty";
    }
    if (
      !fields.isMorningChecked &&
      !fields.isAfternoonChecked &&
      !fields.isEveningChecked
    ) {
      formIsValid = false;
      newErrors.slots = "At least one slot period must be selected.";
    }
    if (
      fields.isEarlyMorningChecked &&
      (!fields.early_morning_from || !fields.early_morning_to)
    ) {
      formIsValid = false;
      newErrors.early_morning_range =
        "Select both 'from' and 'to' for Early Morning.";
    }
    if (
      fields.isMorningChecked &&
      (!fields.morning_range_from || !fields.morning_range_to)
    ) {
      formIsValid = false;
      newErrors.morning_range = "Select both 'from' and 'to' for Morning.";
    }
    if (fields.isAfternoonChecked && (!fields.noon_from || !fields.noon_to)) {
      formIsValid = false;
      newErrors.afternoon_range = "Select both 'from' and 'to' for Afternoon.";
    }
    if (
      fields.isEveningChecked &&
      (!fields.evening_from || !fields.evening_to)
    ) {
      formIsValid = false;
      newErrors.evening_range = "Select both 'from' and 'to' for Evening.";
    }
    setErrors(newErrors);
    return formIsValid;
  }, [fields]);

  // Date handlers
  const setStartDateOnChange = useCallback((value) => {
    setFields((prev) => {
      // If new start_date is after current end_date, update end_date to match
      let newEndDate = prev.end_date;
      if (value > prev.end_date) {
        newEndDate = value;
      }
      return { ...prev, start_date: value, end_date: newEndDate };
    });
  }, []);

  const setEndDateOnChange = useCallback((value) => {
    setFields((prev) => ({ ...prev, end_date: value }));
  }, []);

  // Clear form fields
  const clearFields = useCallback(() => {
    setFields({
      isEarlyMorningChecked: true,
      isMorningChecked: true,
      isAfternoonChecked: true,
      isEveningChecked: true,
      early_morning_from: "6:00 AM",
      early_morning_to: "8:00 AM",
      morning_range_from: "9:00 AM",
      morning_range_to: "11:00 AM",
      noon_from: "12:00 PM",
      noon_to: "3:00 PM",
      evening_from: "4:00 PM",
      evening_to: "7:00 PM",
      start_date: currentDate,
      end_date: sevenDays,
    });
    setErrors({});
    setSelectedConfigIdx(null);
  }, []);

  return (
    <main>
      <DiagnosisHeader />
      <DiagnosisMenu />
      <section
        id="create_slot_sec"
        style={{
          ...styles.container,
          paddingTop: layoutPadding.paddingTop,
          paddingLeft: layoutPadding.paddingLeft,
        }}
      >
        <form onSubmit={checkSubmit}>
          <div style={{ marginBottom: 12 }}>
            <div style={styles.headerRow}>
              <h2 style={styles.title}>Create Slots</h2>
              <div style={styles.dateGroup}>
                <div>
                  <div style={styles.datePickerWrapper}>
                    <DatePicker
                      minDate={new Date()}
                      name="start_date"
                      autoComplete="off"
                      placeholderText="Start Date"
                      selected={fields.start_date}
                      onChange={setStartDateOnChange}
                      dateFormat="d-MM-yyyy"
                      showMonthDropdown
                      adjustDateOnChange
                      className="custom-datepicker"
                      style={styles.datePickerInput}
                    />
                    <i
                      className="fa fa-calendar"
                      style={styles.calendarIcon}
                    ></i>
                  </div>
                  <div style={{ color: "#d9534f", fontSize: 12 }}>
                    {errors.start_date}
                  </div>
                </div>
                <div style={{ alignSelf: "center" }}>to</div>
                <div>
                  <div style={styles.datePickerWrapper}>
                    <DatePicker
                      minDate={fields.start_date || new Date()}
                      name="end_date"
                      autoComplete="off"
                      placeholderText="End Date"
                      selected={fields.end_date}
                      onChange={setEndDateOnChange}
                      dateFormat="d-MM-yyyy"
                      showMonthDropdown
                      adjustDateOnChange
                      className="custom-datepicker"
                      style={styles.datePickerInput}
                    />
                    <i
                      className="fa fa-calendar"
                      style={styles.calendarIcon}
                    ></i>
                  </div>
                  <div style={{ color: "#d9534f", fontSize: 12 }}>
                    {errors.end_date}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={styles.slotsGrid}>
            {/* Early Morning Period */}
            <div style={styles.slotBox}>
              <div style={styles.slotRow}>
                <label style={styles.slotLabel}>
                  <input
                    type="checkbox"
                    name="early_morning_slot"
                    id="early_morning_slot"
                    checked={fields.isEarlyMorningChecked}
                    onChange={toggleEarlyMorningChange}
                    style={{ marginRight: 8 }}
                  />
                  Early Morning
                </label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    flex: 1,
                  }}
                >
                  <select
                    value={fields.early_morning_from}
                    onChange={(e) => handleChange("early_morning_from", e)}
                    style={styles.select}
                  >
                    {early_morning_slots.map((option) => (
                      <option value={option} key={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                  <div style={styles.arrow} aria-hidden>
                    →
                  </div>
                  <select
                    value={fields.early_morning_to}
                    onChange={(e) => handleChange("early_morning_to", e)}
                    style={styles.select}
                  >
                    {early_morning_slots.slice(1).map((option) => (
                      <option value={option} key={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            {/* Morning Range Period */}
            <div style={styles.slotBox}>
              <div style={styles.slotRow}>
                <label style={styles.slotLabel}>
                  <input
                    type="checkbox"
                    name="morning_slot"
                    id="morning_slot"
                    checked={fields.isMorningChecked}
                    onChange={toggleMorningChange}
                    style={{ marginRight: 8 }}
                  />
                  Morning
                </label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    flex: 1,
                  }}
                >
                  <select
                    value={fields.morning_range_from}
                    onChange={(e) => handleChange("morning_range_from", e)}
                    style={styles.select}
                  >
                    {morning_slots.map((option) => (
                      <option value={option} key={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                  <div style={styles.arrow}>→</div>
                  <select
                    value={fields.morning_range_to}
                    onChange={(e) => handleChange("morning_range_to", e)}
                    style={styles.select}
                  >
                    {morning_slots.slice(1).map((option) => (
                      <option value={option} key={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div style={styles.slotBox}>
              <div style={styles.slotRow}>
                <label style={styles.slotLabel}>
                  <input
                    type="checkbox"
                    name="afternoon_slot"
                    id="afternoon_slot"
                    checked={fields.isAfternoonChecked}
                    onChange={toggleAfternoonChange}
                    style={{ marginRight: 8 }}
                  />
                  Afternoon
                </label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    flex: 1,
                  }}
                >
                  <select
                    value={fields.noon_from}
                    onChange={(e) => handleChange("noon_from", e)}
                    style={styles.select}
                  >
                    {noon_slots.map((option) => (
                      <option value={option} key={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                  <div style={styles.arrow}>→</div>
                  <select
                    value={fields.noon_to}
                    onChange={(e) => handleChange("noon_to", e)}
                    style={styles.select}
                  >
                    {noon_slots.slice(1).map((option) => (
                      <option value={option} key={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div style={styles.slotBox}>
              <div style={styles.slotRow}>
                <label style={styles.slotLabel}>
                  <input
                    type="checkbox"
                    name="evening_slot"
                    id="evening_slot"
                    checked={fields.isEveningChecked}
                    onChange={toggleEveningChange}
                    style={{ marginRight: 8 }}
                  />
                  Evening
                </label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    flex: 1,
                  }}
                >
                  <select
                    value={fields.evening_from}
                    onChange={(e) => handleChange("evening_from", e)}
                    style={styles.select}
                  >
                    {evening_slots.map((option) => (
                      <option value={option} key={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                  <div style={styles.arrow}>→</div>
                  <select
                    value={fields.evening_to}
                    onChange={(e) => handleChange("evening_to", e)}
                    style={styles.select}
                  >
                    {evening_slots.slice(1).map((option) => (
                      <option value={option} key={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div style={{ marginTop: 8 }}>
            <div style={styles.buttonRow}>
              {update === "" ? (
                <button
                  type="submit"
                  style={styles.button}
                  className="custom-button-primary"
                >
                  Save
                </button>
              ) : (
                <button
                  type="submit"
                  style={styles.button}
                  className="custom-button-primary"
                >
                  Update
                </button>
              )}
              <button
                type="button"
                onClick={clearFields}
                style={styles.buttonSecondary}
                className="custom-button-secondary"
              >
                Cancel
              </button>
            </div>

            <div style={{ marginTop: 20 }}>
              <div style={{ marginTop: 8 }}>
                <h4>Configured Date Range & Slots</h4>
                {fetchedSlotConfigs.length === 0 ? (
                  <p>No slots configured yet.</p>
                ) : (
                  <div>
                    {fetchedSlotConfigs.map((config, idx) => (
                      <div
                        key={config.id}
                        style={{
                          marginBottom: 20,
                          border:
                            selectedConfigIdx === idx
                              ? "2px solid #007bff"
                              : "1px solid #ccc",
                          borderRadius: 6,
                          padding: 10,
                        }}
                      >
                        <div
                          style={{
                            marginBottom: 10,
                          }}
                        >
                          <strong>Date Range:</strong> {config.date_range.from}{" "}
                          to {config.date_range.to}
                          <i
                            className="fa fa-edit custom-edit-icon"
                            style={styles.editIcon}
                            title="Edit this configuration"
                            onClick={() => onEditAllSlotsAndDateRange(idx)}
                          ></i>
                        </div>
                        <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                          {Object.entries(config.slots).map(
                            ([period, slots]) => (
                              <li key={period} style={{ marginBottom: 10 }}>
                                <strong>{period}:</strong> {slots.join(", ")}
                              </li>
                            )
                          )}
                        </ul>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </form>
      </section>
    </main>
  );
};

export default SlotsConfiguration;
